
import { 
  Calendar, 
  Users, 
  Search, 
  Building2, 
  Phone, 
  Briefcase,
  Wrench,
  MapPin,
  MessageSquare
} from "lucide-react";

export const EVENT_TYPES = [
  { 
    id: 'interview', 
    label: 'Interview', 
    color: 'bg-blue-200 border-blue-400',
    icon: Users
  },
  { 
    id: 'screening', 
    label: 'Screening', 
    color: 'bg-green-200 border-green-400',
    icon: Phone
  },
  { 
    id: 'technical', 
    label: 'Technical', 
    color: 'bg-red-200 border-red-400',  // Changed from purple to red
    icon: Wrench
  },
  { 
    id: 'onsite', 
    label: 'On-site', 
    color: 'bg-orange-200 border-orange-400',
    icon: MapPin
  },
  { 
    id: 'meeting', 
    label: 'Meeting', 
    color: 'bg-yellow-200 border-yellow-400',
    icon: MessageSquare
  },
  { 
    id: 'other', 
    label: 'Other', 
    color: 'bg-gray-200 border-gray-400',
    icon: Calendar
  },
  { 
    id: 'client', 
    label: 'Client', 
    color: 'bg-cyan-200 border-cyan-400',
    icon: Building2
  },
  { 
    id: 'research', 
    label: 'Research', 
    color: 'bg-rose-200 border-rose-400',  // Changed from pink to rose
    icon: Search
  },
  { 
    id: 'prospecting', 
    label: 'Prospecting', 
    color: 'bg-red-200 border-red-400',  // Changed from indigo to red
    icon: Briefcase
  }
] as const;

export const getEventClass = (type: string): string => {
  const eventType = EVENT_TYPES.find(t => t.id === type);
  return eventType?.color || EVENT_TYPES[EVENT_TYPES.length - 1].color;
};
